export interface PageInfo {
    start: number;
    end: number;
    total: number;
}
